import tableIcons from '../helper/tableIcon';

export default (function () {
  let menuList = [];

  const getMenuList = () => menuList;

  const setMenuList = (value) => {
    menuList = value;
  };

  const getModulesName = (menuListItems) => {
    const moduleNames = [];
    if (menuListItems && menuListItems.length) {
      menuListItems.forEach((item) => {
        const name = item.moduleName;
        moduleNames.push(name);
        if (item.create) {
          moduleNames.push(`${name}C`);
        }
        if (item.read) {
          moduleNames.push(`${name}R`);
        }
        if (item.update) {
          moduleNames.push(`${name}U`);
        }
        if (item.delete) {
          moduleNames.push(`${name}D`);
        }
        if (name === 'licenseGenerate') {
          if (item.copy) {
            moduleNames.push(`${name}Copy`);
          }
          if (item.instance) {
            moduleNames.push(`${name}Instance`);
          }
          if (item.offlineLicense) {
            moduleNames.push(`${name}Offline`);
          }
          if (item.upload) {
            moduleNames.push(`${name}Upload`);
          }
        }
        if (name === 'client') {
          // moduleNames.push(name + 'User');
          if (item.lock) {
            moduleNames.push(`${name}Lock`);
          }
          moduleNames.push(`${name}Verify`);
          moduleNames.push(`${name}Embed`);
        }
      });
    }
    setMenuList(moduleNames);
    return moduleNames;
  };

  const getActionsList = (permissions, actions) => {
    let actionPermissions = permissions;

    if (!(actionPermissions && actionPermissions.permission && Array.isArray(actionPermissions.permission)
      && actionPermissions.permission.length)) {
      actionPermissions = menuList;
    } else {
      actionPermissions = actionPermissions.permission;
    }

    const tempActionList = [];

    if (actionPermissions && Array.isArray(actionPermissions)) {
      if (actions && actions.length) {
        actions.forEach((item) => {
          if (actionPermissions.indexOf(item.action) > -1) {
            if (item.icon === 'add') {
              tempActionList.push({
                icon: tableIcons.Add,
                tooltip: item.title,
                onClick: item.handler,

              });
            } else if (item.icon === 'lock') {
              tempActionList.push({
                icon: tableIcons.LockOpen,
                tooltip: item.title,
                onClick: item.handler,
              });
            } else if (item.icon === 'verifyUser') {
              tempActionList.push({
                icon: tableIcons.VerifiedUser,
                tooltip: item.title,
                onClick: item.handler,
              });
            } else if (item.icon === 'embed') {
              tempActionList.push({
                icon: tableIcons.EmbedCode,
                tooltip: item.title,
                onClick: item.handler,
              });
            } else if (item.icon === 'clientUser') {
              tempActionList.push({
                icon: tableIcons.SupervisedUserCircle,
                tooltip: item.title,
                onClick: item.handler,
              });
            } else if (item.icon === 'clientDomain') {
              tempActionList.push({
                icon: tableIcons.Public,
                tooltip: item.title,
                onClick: item.handler,
              });
            } else if (item.icon === 'licenseGenerateCopy') {
              tempActionList.push({
                icon: tableIcons.GetAppIcon,
                tooltip: item.title,
                onClick: item.handler,
              });
            } else if (item.icon === 'licenseGenerateUpload') {
              tempActionList.push({
                icon: tableIcons.PublishIcon,
                tooltip: item.title,
                onClick: item.handler,
              });
            } else if (item.icon === 'licenseGenerateInstance') {
              tempActionList.push({
                icon: tableIcons.MenuIcon,
                tooltip: item.title,
                onClick: item.handler,
              });
            } else if (item.icon === 'licenseGenerateOffline') {
              tempActionList.push({
                icon: tableIcons.LicenseOffline,
                tooltip: item.title,
                onClick: item.handler,
              });
            } else {
              tempActionList.push({
                icon: item.icon === 'edit' ? tableIcons.Edit : tableIcons.Delete,
                tooltip: item.title,
                onClick: item.handler,

              });
            }
          }
        });
      }
    }
    return tempActionList;
  };

  return {
    getMenuList,
    setMenuList,
    getModulesName,
    getActionsList,
  };
}());
